var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGridiconsCrossCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5559 4.48005C11.241 1.17332 5.80111 1.17332 2.48619 4.48005C-0.82873 7.78678 -0.82873 13.2132 2.48619 16.5199C5.80111 19.8267 11.156 19.8267 14.4709 16.5199C17.7858 13.2132 17.8708 7.78678 14.5559 4.48005ZM10.901 14.0611L8.52104 11.687L6.1411 14.0611L4.95113 12.8741L7.33107 10.5L4.95113 8.12593L6.1411 6.9389L8.52104 9.31297L10.901 6.9389L12.091 8.12593L9.71102 10.5L12.091 12.8741L10.901 14.0611Z",
    fill: "#CF5151"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGridiconsCrossCircle);
export default __webpack_public_path__ + "static/media/gridicons_cross-circle.e1930eaa63f780dffb82a98622349078.svg";
export { ForwardRef as ReactComponent };